import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getRandomColor } from '../../utils/colors';
import { useRandomLinkColors } from '../../utils/useRandomLinkColors';
const Header = () => {
  // Use our custom hook
  const isMobile = useRandomLinkColors();
  // Apply random colors to header links immediately
  useEffect(() => {
    const headerLinks = document.querySelectorAll('header a');
    headerLinks.forEach(link => {
      // Always apply a random color on initial render, regardless of data-color-applied attribute
      link.style.color = getRandomColor();
      link.dataset.colorApplied = 'true';
    });
  }, []);
  return <header className="fixed top-0 w-full flex justify-end px-6 py-6 z-10 bg-[#faf9f7]" data-id="element-629" data-mp="2vcvvgzqb2out">
      <div className="flex space-x-6" data-id="element-630" data-mp="30anwqkcubnbo">
        <div className="text-base font-normal" data-id="element-631" data-mp="3o1t8anbqztg6">
          <Link to="/" className="transition-colors duration-200"
        // Apply random color directly in the JSX
        style={{
          color: getRandomColor()
        }} data-color-applied="true" data-id="element-632" data-mp="3o11hrqx0clwr">
            Madeleine Morlet
          </Link>
        </div>
        <div className="text-base font-normal" data-id="element-633" data-mp="2jummkgz6t1jp">
          <Link to="/info" className="transition-colors duration-200"
        // Apply random color directly in the JSX
        style={{
          color: getRandomColor()
        }} data-color-applied="true" data-id="element-634" data-mp="2xodszghmg5b7">
            Info
          </Link>
        </div>
      </div>
    </header>;
};
export default Header;